import type { oz } from '@weft/utils';
import { NewBankDetailsSchema } from './new-bank-details-schema';

export const BankDetailsSchema = NewBankDetailsSchema.openapi('BankDetails');

export type BankDetails = oz.infer<typeof BankDetailsSchema>;